import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as React from "react";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  getInventoryItemStatusListingAction,
  getWareHouseDetailsByIdAction,
  getWareHouseListingAction,
  updateInventoryQuantityAction,
} from "src/app-redux/warehouse/actions/wareHouseActions";
import {
  selectInventoryItemStatusListing,
  selectWareHouseItemDetails,
  selectWareHouseListing,
} from "src/app-redux/warehouse/wareHouseSlice";
import CommonButton from "src/components/CommonButton/CommonButton";
import { number, object, string } from "yup";
import { useStyles } from "./../style";

export interface IDrawerStatusProps {}
import moment from "moment";
import { disableCopy, disablePaste, validationNumber } from "src/common/utils/formValidation";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { fetchWrapper } from "src/api-client/fetchWrapper";

export default function DrawerQuantity(props: IDrawerStatusProps) {
  const classes = useStyles();
  const inventoryItemDetails: any = useAppSelector(selectWareHouseItemDetails);
  const dispatch = useAppDispatch();
  const [weight, setWeight] = React.useState<any>("");
  const [cargoValue, setCargoValue] = React.useState<any>("");
  const [dimensionLength, setDimensionLength] = React.useState<any>("");
  const [dimensionWidth, setDimensionWidth] = React.useState<any>("");
  const [dimensionHeight, setDimensionHeight] = React.useState<any>("");

  const validationSchema = object({
    cargoValue: number()
      .min(0, "Minimum 0 is allowed")
      .max(1000000000, "Maximum 10 digits are allowed"),
    weight: number()
      .min(0, "Minimum 0 is allowed")
      .max(1000000000, "Maximum 10 digits are allowed"),
    dimensionLength: number()
      .min(0, "Minimum 0 is allowed")
      .max(1000000000, "Maximum 10 digits are allowed"),
    dimensionWidth: number()
      .min(0, "Minimum 0 is allowed")
      .max(1000000000, "Maximum 10 digits are allowed"),
    dimensionHeight: number()
      .min(0, "Minimum 0 is allowed")
      .max(1000000000, "Maximum 10 digits are allowed"),
    remarks: string().max(3000, "Maximum 3000 characters allowed"),
    itemRemarks: string().max(3000, "Maximum 3000 characters allowed"),
    supplierName: number().required("This field is required"),
    regNumber: string().when("IsReceived", {
      is: (value: any) => {
        if (formik.values.IsReceived == 0) {
          return true;
        }
        // return !value;
      },
      then: string().required("This field is required"),
      otherwise: string(),
    }),
    // .matches(/^[a-zA-Z ]*$/, "Only alphabets are allowed for this field "),
  });
  const [IsReceived, setReceive] = React.useState(1);
  const formik = useFormik<any>({
    enableReinitialize: true,
    initialValues: {
      regNumber: "",
      itemId: inventoryItemDetails.itemDetail?.inventoryItemId,
      IsReceived: IsReceived,
      ItemWeight: 0,
      inventoryId: inventoryItemDetails.itemDetail?.id || "",
      entryDate:
        inventoryItemDetails.itemDetail?.entryDate || moment(new Date()).format("YYYY-MM-DDTHH:mm"),
      remarks: inventoryItemDetails.itemDetail?.remarks || "",
      itemRemarks: inventoryItemDetails.itemDetail?.itemRemarks || "",
      weight: inventoryItemDetails.itemDetail?.weight || 0,
      dimensionLength: inventoryItemDetails.itemDetail?.dimensionLength || 0,
      dimensionWidth: inventoryItemDetails.itemDetail?.dimensionWidth || 0,
      dimensionHeight: inventoryItemDetails.itemDetail?.dimensionHeight || 0,
      cargoValue: inventoryItemDetails.itemDetail?.cargoValue || 0,
      weightUnit: inventoryItemDetails.itemDetail?.weightUnitId,
      dimensionUnit: inventoryItemDetails.itemDetail?.weightUnitId,
      currency: "PKR",
      quantityUpdate: 1,
      supplierName: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      const { IsReceived } = values;
      setReceive(IsReceived);
      if (Number(inventoryItemDetails?.itemDetail?.statusId) == 2) {
        return dispatch(
          addNotificationAction({
            message: "Out-of-warehouse item cannot be updated",
            options: { variant: "error" },
          })
        );
      }
      const res: any = await dispatch(updateInventoryQuantityAction(values));
      if (res.payload) {
        resetStatusForm();
        actions.setSubmitting(false);
        dispatch(getWareHouseDetailsByIdAction(inventoryItemDetails.itemDetail?.id));
        return;
      }
    },
  });
  // Redux
  const wareHouseListing = useAppSelector(selectWareHouseListing);
  const inventoryItemStatusListing = useAppSelector(selectInventoryItemStatusListing);

  React.useEffect(() => {
    if (wareHouseListing.length === 0) dispatch(getWareHouseListingAction());
    if (inventoryItemStatusListing.length === 0) dispatch(getInventoryItemStatusListingAction());
    getListing();
  }, []);
  const resetStatusForm = () => {
    setWeight("");
    setCargoValue("");
    setDimensionHeight("");
    setDimensionLength("");
    setDimensionWidth("");
    formik.setFieldValue("regNumber", "");
    formik.setFieldValue("itemRemarks", "");
    formik.setFieldValue("remarks", "");
    // formik.setFieldValue("weight", "");
    formik.setFieldValue("dimensionLength", "");
    formik.setFieldValue("dimensionWidth", "");
    formik.setFieldValue("dimensionWidth", "");
    formik.setFieldValue("dimensionHeight", "");
    formik.setFieldValue("cargoValue", "");
    // formik.setFieldValue("weightUnit", "");
    formik.setFieldValue("dimensionUnit", "");
    formik.setFieldValue("currency", "PKR");
    formik.setFieldValue("supplierName", "");
  };
  const resetForm = () => {
    formik.setFieldValue("regNumber", "");
    formik.setFieldValue("supplierName", "");
    formik.setFieldValue("itemRemarks", "");
    formik.setFieldValue("remarks", "");
  };

  const weightAddHandler = async () => {
    if (formik.isValid) {
      formik.setFieldValue("regNumber", inventoryItemDetails.itemDetail?.vehicleNumber);
      formik.setFieldValue("quantityUpdate", 1);
      formik.setFieldValue("IsReceived", 1);
      formik.setFieldValue("ItemWeight", Number(weight));
      const value = await (Number(weight) + Number(formik.values.weight));
      await formik.setFieldValue("weight", Number(value));
    }
    formik.submitForm();
  };

  const weightRemoveHandler = async () => {
    if (formik.isValid) {
      if (Number(weight) <= Number(formik.values.weight)) {
        formik.setFieldValue("IsReceived", 0);
        formik.setFieldValue("quantityUpdate", 1);
        formik.setFieldValue("ItemWeight", Number(weight));
        const value = await (Number(formik.values.weight) - Number(weight));
        await formik.setFieldValue("weight", value);
      }
    }
    formik.submitForm();
  };

  // const cargoValueAddHandler = async () => {
  //   if (formik.isValid) {
  //     formik.setFieldValue("quantityUpdate", 3);
  //     const value = await (Number(cargoValue) + Number(formik.values.cargoValue));
  //     await formik.setFieldValue("cargoValue", Number(value));
  //   }
  //   formik.submitForm();
  // };

  // const cargoValueRemoveHandler = async () => {
  //   if (formik.isValid) {
  //     if (Number(cargoValue) <= Number(formik.values.cargoValue)) {
  //       formik.setFieldValue("quantityUpdate", 3);
  //       const value = await (Number(formik.values.cargoValue) - Number(cargoValue));
  //       await formik.setFieldValue("cargoValue", value);
  //     }
  //   }
  //   formik.submitForm();
  // };

  // const sizeAddHandler = async () => {
  //   if (formik.isValid) {
  //     formik.setFieldValue("quantityUpdate", 2);
  //     const sumDimensionLength = await (Number(dimensionLength) +
  //       Number(formik.values.dimensionLength));
  //     const sumDimensionWidth = await (Number(dimensionWidth) +
  //       Number(formik.values.dimensionWidth));
  //     const sumDimensionHeight = await (Number(dimensionHeight) +
  //       Number(formik.values.dimensionHeight));

  //     await formik.setFieldValue("dimensionLength", Number(sumDimensionLength));
  //     await formik.setFieldValue("dimensionWidth", Number(sumDimensionWidth));
  //     await formik.setFieldValue("dimensionHeight", Number(sumDimensionHeight));
  //   }
  //   formik.submitForm();
  // };

  // const sizeRemoveHandler = async () => {
  //   if (formik.isValid) {
  //     if (
  //       Number(dimensionLength) <= Number(formik.values.dimensionLength) &&
  //       Number(dimensionWidth) <= Number(formik.values.dimensionWidth) &&
  //       Number(dimensionHeight) <= Number(formik.values.dimensionHeight)
  //     ) {
  //       formik.setFieldValue("quantityUpdate", 2);
  //       const sumDimensionLength = await (Number(formik.values.dimensionLength) -
  //         Number(dimensionLength));
  //       const sumDimensionWidth = await (Number(formik.values.dimensionWidth) -
  //         Number(dimensionWidth));
  //       const sumDimensionHeight = await (Number(formik.values.dimensionHeight) -
  //         Number(dimensionHeight));

  //       await formik.setFieldValue("dimensionLength", Number(sumDimensionLength));
  //       await formik.setFieldValue("dimensionWidth", Number(sumDimensionWidth));
  //       await formik.setFieldValue("dimensionHeight", Number(sumDimensionHeight));
  //     }
  //   }
  //   formik.submitForm();
  // };

  const [supplierTypeList, setSupplierTypeList] = React.useState([]);

  const getListing = async () => {
    let results: any = [];
    try {
      results = await fetchWrapper.get(`get_all-supplier-details?getActiveSuppliersOnly=${true}`);
      if (results.isSuccess == true) {
        results.value.sort((a: any, b: any) => b.supplierType.localeCompare(a.supplierType));
        setSupplierTypeList(results.value);
      }
      return;
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  return (
    <div className={classes.drawerDetails}>
      {/* Drawer Quantity Item  */}
      <Grid container spacing={3} className="topContainer">
        <Grid container direction="row" className="itemRow" spacing={1}>
          <Grid
            item
            xs={12}
            md={12}
            container
            direction="row"
            justifyContent="space-between"
            className="itemRow"
          >
            <Grid item xs={12} md={12} style={{ paddingBottom: 20 }}>
              <Box>
                <FormControl component="fieldset">
                  {/* <FormLabel component="legend" className={classes.legend}>
                    label
                  </FormLabel> */}
                  <RadioGroup
                    row
                    aria-label="terminalLocationId"
                    name="terminalLocationId"
                    value={formik.values.IsReceived}
                    onChange={(event: any) => {
                      formik.setFieldValue("IsReceived", Number(event.target.value));
                      setWeight("");
                      resetForm();
                    }}
                  >
                    <FormControlLabel
                      style={{ marginRight: "10px" }}
                      value={1}
                      control={<Radio />}
                      label="ADD"
                    />
                    <FormControlLabel
                      style={{ marginRight: "10px" }}
                      value={0}
                      control={<Radio />}
                      label="ISSUE"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} style={{ paddingBottom: "20px", marginRight: "5px" }}>
              <Box>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  label={formik.values.IsReceived == 0 ? "Issued to" : "Added by"}
                  placeholder="Select Importer/Exporter Name"
                  name="supplierName"
                  optionsType={supplierTypeList}
                  getOptionLabel={(option: any) =>
                    option.supplierName && option.supplierType
                      ? `${option.supplierType} - ${option.supplierName}`
                      : option.supplierName
                      ? option.supplierName
                      : ""
                  }
                  renderOption={(option) => (
                    <span>
                      {option.supplierName && option.supplierType
                        ? `${option.supplierType} - ${option.supplierName}`
                        : option.supplierName
                        ? option.supplierName
                        : ""}
                    </span>
                  )}
                  required
                  value={
                    supplierTypeList.find((st: any) => st.id === formik.values.supplierName) || null
                  }
                  onChange={(option: any) => {
                    option && option !== "" ? formik.setFieldValue("supplierName", option.id) : "";
                  }}
                  error={formik.touched.supplierName && Boolean(formik.errors.supplierName)}
                  helperText={formik.touched.supplierName && formik.errors.supplierName}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box>
                <Typography>
                  <span style={{ fontWeight: "bold" }}> Current Quantity: </span>
                  {Number(inventoryItemDetails.itemDetail?.weight).toFixed(2)} {""}{" "}
                  {inventoryItemDetails.itemDetail?.weight
                    ? inventoryItemDetails.itemDetail?.weightUnit == "Cubic meter"
                      ? "m³"
                      : inventoryItemDetails.itemDetail?.weightUnit
                    : ""}
                </Typography>
                <Box style={{ display: "flex" }}>
                  <TextField
                    // style={{ width: "220px" }}
                    className={"customTextField"}
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // label="Weight"
                    name="weight"
                    placeholder="Enter Quantity"
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    error={formik.touched.weight && Boolean(formik.errors.weight)}
                    helperText={formik.touched.weight && formik.errors.weight}
                    onBlur={() => {
                      const num = parseFloat(formik.values.weight || 0);
                      const cleanNum = num.toFixed(2);
                      formik.setFieldValue("weight", cleanNum);
                    }}
                    onKeyDown={(evt) => validationNumber(evt)}
                    onCopy={disableCopy}
                    onPaste={disablePaste}
                    onCut={disableCopy}
                  />
                  <Typography style={{ margin: "12px 0px 0px 2px" }}>
                    {inventoryItemDetails.itemDetail?.weight
                      ? inventoryItemDetails.itemDetail?.weightUnit == "Cubic meter"
                        ? "m³"
                        : inventoryItemDetails.itemDetail?.weightUnit
                      : ""}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            {formik.values.IsReceived == 0 && (
              <Grid item xs={12} style={{ marginTop: "30px", marginRight: "5px" }}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Vehicle Number"
                    placeholder="Select Vehilce Number"
                    name="vehicleNumber"
                    optionsType={inventoryItemDetails?.emptyVehiclesDetails}
                    getOptionLabel={(option: any) => option.vehicleNumber}
                    renderOption={(option) => <span>{option.vehicleNumber}</span>}
                    required
                    value={
                      inventoryItemDetails?.emptyVehiclesDetails.find(
                        (st: any) => st?.vehicleNumber === formik.values.regNumber
                      ) || null
                    }
                    onChange={(option: any) => {
                      option && option !== ""
                        ? formik.setFieldValue("regNumber", option.vehicleNumber)
                        : "";
                    }}
                    error={formik.touched.regNumber && Boolean(formik.errors.regNumber)}
                    helperText={formik.touched.regNumber && formik.errors.regNumber}
                  />
                </Box>
              </Grid>
            )}
            <Grid item xs={12} md={12} lg={12} style={{ marginTop: "30px" }}>
              <Box>
                <TextField
                  multiline
                  rows={2}
                  rowsMax={5}
                  size="small"
                  fullWidth
                  className="customTextField"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Remarks"
                  name="notes"
                  id="notes"
                  placeholder="Enter Remarks"
                  disabled={false}
                  value={formik.values.itemRemarks}
                  onChange={(e: any) => formik.setFieldValue("itemRemarks", e.target.value)}
                  error={formik.touched.itemRemarks && Boolean(formik.errors.itemRemarks)}
                  helperText={formik.touched.itemRemarks && formik.errors.itemRemarks}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box
                style={{ display: "flex", textAlign: "end", marginTop: "25px", marginLeft: "11px" }}
              >
                {formik.values.IsReceived == 1 ? (
                  <Box style={{ marginRight: "5px" }}>
                    <CommonButton
                      cssClass="customSubmitBtn"
                      isGreen
                      disable={!weight || weight == 0}
                      onClick={() => weightAddHandler()}
                    >
                      Add
                    </CommonButton>{" "}
                  </Box>
                ) : (
                  <Box style={{ marginRight: "5px" }}>
                    <CommonButton
                      cssClass="customSubmitBtn"
                      isGreen
                      disable={
                        !weight ||
                        weight == 0 ||
                        Number(weight) > Number(inventoryItemDetails.itemDetail?.weight)
                      }
                      onClick={() => weightRemoveHandler()}
                    >
                      Issue
                    </CommonButton>{" "}
                  </Box>
                )}
                <CommonButton
                  cssClass="customSubmitBtn"
                  onClick={() => {
                    resetStatusForm();
                  }}
                >
                  Reset
                </CommonButton>
              </Box>
            </Grid>
          </Grid>

          {/* <Grid
            item
            xs={12}
            md={12}
            container
            direction="row"
            justifyContent="space-between"
            className="itemRow"
          >
            <Grid item xs={12} md={8} lg={8}>
              <Box>
                <Typography>
                  <span style={{ fontWeight: "bold" }}>Current Size: </span>
                  {Number(inventoryItemDetails.itemDetail?.dimensionLength).toFixed(2)}x
                  {Number(inventoryItemDetails.itemDetail?.dimensionWidth).toFixed(2)}x
                  {Number(inventoryItemDetails.itemDetail?.dimensionHeight).toFixed(2)}{" "}
                  {inventoryItemDetails.itemDetail?.dimensionLength ||
                  inventoryItemDetails.itemDetail?.dimensionWidth ||
                  inventoryItemDetails.itemDetail?.dimensionHeight
                    ? inventoryItemDetails.itemDetail?.weightUnit
                    : ""}
                </Typography>
                <Box style={{ display: "flex" }}>
                  <TextField
                    style={{ width: "87px" }}
                    className={"customTextField"}
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    size="small"
                    // fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // label="Length"
                    name="dimensionLength"
                    placeholder="Length"
                    disabled={false}
                    value={dimensionLength}
                    onChange={(e) => setDimensionLength(e.target.value)}
                    error={formik.touched.dimensionLength && Boolean(formik.errors.dimensionLength)}
                    helperText={formik.touched.dimensionLength && formik.errors.dimensionLength}
                    onBlur={() => {
                      const num = parseFloat(formik.values.dimensionLength || 0);
                      const cleanNum = num.toFixed(2);
                      formik.setFieldValue("dimensionLength", cleanNum);
                    }}
                    onKeyDown={(evt) => validationNumber(evt)}
                    onCopy={disableCopy}
                    onPaste={disablePaste}
                    onCut={disableCopy}
                  />

                  <TextField
                    style={{ width: "87px", margin: "0px 5px 0px 5px" }}
                    className={"customTextField"}
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    size="small"
                    // fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // label="Width"
                    name="dimensionWidth"
                    placeholder="Width"
                    disabled={false}
                    value={dimensionWidth}
                    onChange={(e) => setDimensionWidth(e.target.value)}
                    error={formik.touched.dimensionWidth && Boolean(formik.errors.dimensionWidth)}
                    helperText={formik.touched.dimensionWidth && formik.errors.dimensionWidth}
                    onBlur={() => {
                      const num = parseFloat(formik.values.dimensionWidth || 0);
                      const cleanNum = num.toFixed(2);
                      formik.setFieldValue("dimensionWidth", cleanNum);
                    }}
                    onKeyDown={(evt) => validationNumber(evt)}
                    onCopy={disableCopy}
                    onPaste={disablePaste}
                    onCut={disableCopy}
                  />

                  <TextField
                    style={{ width: "87px" }}
                    className={"customTextField"}
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    size="small"
                    // fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // label="Height"
                    name="dimensionHeight"
                    placeholder="Height"
                    disabled={false}
                    value={dimensionHeight}
                    onChange={(e) => setDimensionHeight(e.target.value)}
                    error={formik.touched.dimensionHeight && Boolean(formik.errors.dimensionHeight)}
                    helperText={formik.touched.dimensionHeight && formik.errors.dimensionHeight}
                    onBlur={() => {
                      const num = parseFloat(formik.values.dimensionHeight || 0);
                      const cleanNum = num.toFixed(2);
                      formik.setFieldValue("dimensionHeight", cleanNum);
                    }}
                    onKeyDown={(evt) => validationNumber(evt)}
                    onCopy={disableCopy}
                    onPaste={disablePaste}
                    onCut={disableCopy}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={4} lg={4}>
              <Box
                style={{ display: "flex", textAlign: "end", marginTop: "25px", marginLeft: "11px" }}
              >
                <Box style={{ marginRight: "5px" }}>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    isGreen
                    disable={
                      (!dimensionLength && !dimensionWidth && !dimensionHeight) ||
                      (dimensionLength == 0 && dimensionWidth == 0 && dimensionHeight == 0)
                    }
                    onClick={() => sizeAddHandler()}
                  >
                    Add
                  </CommonButton>{" "}
                </Box>
                <Box>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    // isGreen
                    disable={
                      (!dimensionLength && !dimensionWidth && !dimensionHeight) ||
                      (dimensionLength == 0 && dimensionWidth == 0 && dimensionHeight == 0) ||
                      Number(dimensionLength) >
                        Number(inventoryItemDetails.itemDetail?.dimensionLength) ||
                      Number(dimensionWidth) >
                        Number(inventoryItemDetails.itemDetail?.dimensionWidth) ||
                      Number(dimensionHeight) >
                        Number(inventoryItemDetails.itemDetail?.dimensionHeight)
                    }
                    onClick={() => sizeRemoveHandler()}
                  >
                    Remove
                  </CommonButton>{" "}
                </Box>
              </Box>
            </Grid>
          </Grid> */}

          {/* <Grid
            item
            xs={12}
            md={12}
            container
            direction="row"
            justifyContent="space-between"
            className="itemRow"
          >
            <Grid item xs={12} md={7} lg={7}>
              <Box>
                <Typography>
                  <span style={{ fontWeight: "bold" }}>Current Value: </span>
                  {Number(inventoryItemDetails.itemDetail?.cargoValue || 0).toFixed(2)}{" "}
                  {inventoryItemDetails.itemDetail?.cargoValueCurrency}
                </Typography>
                <Box style={{ display: "flex" }}>
                  <TextField
                    style={{ width: "220px" }}
                    className={"customTextField"}
                    size="small"
                    // fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    // label="Value"
                    name="cargoValue"
                    placeholder="Enter Value"
                    disabled={false}
                    value={cargoValue}
                    onChange={(e) => setCargoValue(e.target.value)}
                    error={formik.touched.cargoValue && Boolean(formik.errors.cargoValue)}
                    helperText={formik.touched.cargoValue && formik.errors.cargoValue}
                    onKeyDown={(evt) => validationNumber(evt)}
                    onCopy={disableCopy}
                    onPaste={disablePaste}
                    onCut={disableCopy}
                  />
                  <Typography style={{ margin: "12px 0px 0px 2px" }}>
                    {inventoryItemDetails.itemDetail?.cargoValueCurrency}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Box
                style={{ display: "flex", textAlign: "end", marginTop: "25px", marginLeft: "11px" }}
              >
                <Box style={{ marginRight: "5px" }}>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    isGreen
                    disable={!cargoValue || cargoValue == 0}
                    onClick={() => cargoValueAddHandler()}
                  >
                    Add
                  </CommonButton>{" "}
                </Box>
                <Box>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    // isGreen
                    disable={
                      !cargoValue ||
                      cargoValue == 0 ||
                      Number(cargoValue) > Number(inventoryItemDetails.itemDetail?.cargoValue)
                    }
                    onClick={() => cargoValueRemoveHandler()}
                  >
                    Issue
                  </CommonButton>{" "}
                </Box>
              </Box>
            </Grid>
          </Grid> */}
        </Grid>
      </Grid>
    </div>
  );
}
